import { Grid, TextField, Typography } from "@mui/material";
import DatePickerDefault from "../../DatePickerDefault/DatePickerDefault";
import { styles } from "../../../pages/Storage/shared/styles";
import { StyledIcon } from "../../StyledIcon/StyledIcon";
import { DataField } from "./DataField";
import { Row } from "../../../modules/storage/models/storage-dto";
import { applyVolumeMask } from "../../../utils";
import { FormikProps } from "formik";
import { InitialValues } from "../../../pages/Storage/models/types";

interface Props {
  data: Row;
  formik: FormikProps<InitialValues>;
  isDischarge: boolean;
  isViewing: boolean;
  scheduleDateValue: Date | null;
  setScheduleDate: (d: Date | null) => void;
  scheduleTime: string;
  setScheduleTime: (v: string) => void;
  orderDateValue: Date | null;
  setOrderDate: (d: Date | null) => void;
  setVolumeRequested: (value: string) => void;
}

export const HeaderFields: React.FC<Props> = ({
  data,
  formik,
  orderDateValue,
  setOrderDate,
  setVolumeRequested,
  isDischarge,
  isViewing,
  scheduleDateValue,
  setScheduleDate,
  scheduleTime,
  setScheduleTime,
}) => (
  <>
    <Grid container justifyContent="space-between">
      <Grid container item gap={1} xs="auto">
        <Grid item>
          <StyledIcon iconType="list" sx={{ height: "5rem", width: "5rem" }} />
        </Grid>

        <Grid item>
          <DataField
            title={data.contract?.customerCompany?.description || ""}
            status={data.status}
          />
        </Grid>
      </Grid>

      <Grid item xs="auto">
        <DataField
          title="Produto"
          subtitle={data.contract?.product?.description}
          status={data.status}
        />
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <Typography
          sx={{ mb: 0.5, fontWeight: 700, fontFamily: "Open Sans" }}
          color="shadesOfDark.dark"
        >
          Volume Solicitado
        </Typography>

        <TextField
          variant="outlined"
          size="small"
          value={applyVolumeMask(String(formik.values.volumeRequested || ""))}
          onChange={(e) => setVolumeRequested(e.target.value)}
          error={Boolean(formik.errors.volumeRequested)}
          helperText={formik.errors.volumeRequested || ""}
          disabled={isViewing}
          sx={styles.textField}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePickerDefault
          label={isDischarge ? "Data da NF" : "Data da Fatura"}
          value={orderDateValue}
          onChange={setOrderDate}
          disabled={isViewing}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <DatePickerDefault
          label={
            isDischarge ? "Data da Programação" : "Data prevista (atracação)"
          }
          value={scheduleDateValue}
          onChange={setScheduleDate}
          disabled={isViewing}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography
          color="shadesOfDark.dark"
          sx={{ mb: 0.5, fontWeight: 700, fontFamily: "Open Sans" }}
        >
          {isDischarge ? "Hora da Programação" : "Hora prevista (atracação)"}
        </Typography>

        <TextField
          variant="outlined"
          size="small"
          type="time"
          value={scheduleTime}
          onChange={(e) => setScheduleTime(e.target.value)}
          disabled={isViewing}
          sx={styles.textField}
        />
      </Grid>
    </Grid>
  </>
);
